import { gql } from 'graphql-request';

export default gql`
  query Interactions(
    $skip: Int
    $take: Int
    $orderBy: JSON
    $filters: JSON
    $mask: String
  ) {
    interactions(
      skip: $skip
      take: $take
      orderBy: $orderBy
      filters: $filters
      mask: $mask
    ) {
      totalCount
      skip
      take
      interactions {
        id
        account_id
        legs {
          id
          doc
        }
        doc
        createdAt
        updatedAt
      }
    }
  }
`;
